import { render, staticRenderFns } from "./ResumeUserInformation.vue?vue&type=template&id=2f703bb3&scoped=true&"
import script from "./ResumeUserInformation.vue?vue&type=script&lang=js&"
export * from "./ResumeUserInformation.vue?vue&type=script&lang=js&"
import style0 from "./ResumeUserInformation.vue?vue&type=style&index=0&id=2f703bb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f703bb3",
  null
  
)

export default component.exports